import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const STATUS_CLS = {
  sent: "bg-emerald-100 text-emerald-800 border-emerald-300",
  failed: "bg-red-100 text-red-700 border-red-300",
  skipped_no_smtp: "bg-slate-100 text-slate-600 border-slate-300",
  skipped_no_twilio: "bg-slate-100 text-slate-600 border-slate-300",
  skipped_no_recipient: "bg-slate-100 text-slate-600 border-slate-300",
};

export default function AdminEmails() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/platform/mail-log", { params: { limit: 200 } }).then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div data-testid="admin-emails-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Email & SMS Log</h1>
        <p className="mt-1 text-sm text-muted-foreground">Every dispatch the platform attempted — sent, skipped (no SMTP/Twilio configured) or failed.</p>
      </div>
      <div className="border border-border bg-white">
        <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left">
              {["When", "Type", "To", "Subject / Body", "Status"].map((h) => (
                <th key={h} className="px-5 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-border last:border-0" data-testid={`mail-row-${r.id}`}>
                <td className="px-5 py-3 text-xs tabular-nums text-muted-foreground">{(r.at || "").replace("T", " ").slice(0, 19)}</td>
                <td className="px-5 py-3"><span className="border border-border bg-muted px-2 py-0.5 text-xs font-semibold">{r.kind}</span></td>
                <td className="px-5 py-3 text-xs">{r.to || "—"}</td>
                <td className="max-w-md truncate px-5 py-3 text-xs text-muted-foreground" title={r.error || r.subject}>{r.subject}{r.error ? ` — ${r.error}` : ""}</td>
                <td className="px-5 py-3"><span className={`border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${STATUS_CLS[r.status] || STATUS_CLS.failed}`} data-testid={`mail-status-${r.id}`}>{(r.status || "").replace(/_/g, " ")}</span></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-muted-foreground"><Mail className="mx-auto mb-2 h-5 w-5" />Nothing dispatched yet.</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
